import { useNavigate } from "react-router";
import { Button, Typography } from "antd";

import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";

export default function SendSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Typography.Title level={3} className={styles.title}>
        {t("pages.forgotPassword.sentTitle")}
      </Typography.Title>
      <Typography.Paragraph className={styles.secondary}>
        {t("pages.forgotPassword.sentDescription")}
      </Typography.Paragraph>
      <div className={styles.action}>
        <Button type="link" onClick={() => navigate("/sign-in")}>
          {t("common.backToLogin")}
        </Button>
      </div>
    </>
  );
}
